/**
 * Color Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.colorFormatter = function(value, row) {
    let color = row.color;
    return '<i class="fa fa-circle" style="color: '+color+'"></i>';
};
